/**
 * Forthbridge Clinical Document
 * Forthbridge Clinical Document API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentRelationshipRequestDto } from './documentRelationshipRequestDto';
import { DocumentContentRequestDto } from './documentContentRequestDto';


export interface PatchDocumentReferenceRequestDto { 
    /**
     * Document type identifier
     */
    documentTypeId?: string;
    /**
     * Subject of the document
     */
    subject?: string;
    /**
     * Subject type (patient, encounter, etc.)
     */
    subjectType?: string;
    /**
     * Author of the document
     */
    author?: string;
    /**
     * Status of the document
     */
    status?: PatchDocumentReferenceRequestDto.StatusEnum;
    /**
     * Security level of the document
     */
    security?: PatchDocumentReferenceRequestDto.SecurityEnum;
    /**
     * Content of the document
     */
    content?: DocumentContentRequestDto;
    /**
     * Document relationships
     */
    relationships?: Array<DocumentRelationshipRequestDto>;
    /**
     * Additional metadata
     */
    metadata?: any;
    /**
     * Updater identifier
     */
    updatedBy?: string;
}
export namespace PatchDocumentReferenceRequestDto {
    export type StatusEnum = 'open' | 'closed' | 'on_hold';
    export const StatusEnum = {
        Open: 'open' as StatusEnum,
        Closed: 'closed' as StatusEnum,
        OnHold: 'on_hold' as StatusEnum
    };
    export type SecurityEnum = 'public' | 'confidential' | 'restricted' | 'very_restricted';
    export const SecurityEnum = {
        Public: 'public' as SecurityEnum,
        Confidential: 'confidential' as SecurityEnum,
        Restricted: 'restricted' as SecurityEnum,
        VeryRestricted: 'very_restricted' as SecurityEnum
    };
}


